import { Link as PrimitiveLink } from '@basehub/tiptap-api-utils'
import { getAttributes } from '@tiptap/core'
import { Plugin, PluginKey } from '@tiptap/pm/state'
import { commandKeyPressed } from '~/lib/command-key-pressed'

export const Link = PrimitiveLink.extend({
  addProseMirrorPlugins() {
    const plugins: Plugin[] = []

    if (this.options.redirect) {
      plugins.push(clickHandler(this.options.redirect))
    }

    return plugins
  },
})

function clickHandler(redirect: (url: string) => void = () => {}): Plugin {
  return new Plugin({
    key: new PluginKey('handleClickLink'),
    props: {
      handleClick: (view, pos, event) => {
        if (event.button !== 0 || !commandKeyPressed(event)) {
          return false
        }

        const attrs = getAttributes(view.state, 'link')
        const link = (event.target as HTMLElement)?.closest('a')
        const isInternalLink = link?.getAttribute('data-target-id')

        if (isInternalLink) {
          const sourceId = link?.getAttribute('data-target-id')
          if (sourceId) {
            redirect(sourceId)
            return true
          }
        }

        const href = link?.href ?? attrs.href
        const target = '_blank'

        if (link && href) {
          window.open(href, target)
          return true
        }

        return false
      },
    },
  })
}
